import { render, staticRenderFns } from "./com-box2.vue?vue&type=template&id=9c211002&scoped=true&"
import script from "./com-box2.vue?vue&type=script&lang=js&"
export * from "./com-box2.vue?vue&type=script&lang=js&"
import style0 from "./com-box2.vue?vue&type=style&index=0&id=9c211002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c211002",
  null
  
)

export default component.exports